namespace appn.views.billing.index {

    class InitArgs {
        userPrmYearRates: Array<UserRate> = [];
        userPrmMonthRates: Array<UserRate> = [];
        userStdYearRates: Array<UserRate> = [];
        userStdMonthRates: Array<UserRate> = [];
        userEdgeYearRates: Array<UserRate> = [];
        userEdgeMonthRates: Array<UserRate> = [];
        userProYearRates: Array<UserRate> = [];
        userProMonthRates: Array<UserRate> = [];
        userGFYearRates: Array<UserRate> = [];
        userGFMonthRates: Array<UserRate> = [];
        serviceYearRates: ServiceRates = {};
        serviceMonthRates: ServiceRates = {};
        isTranched: boolean = false;
        minimumUsersToBill: number = 0;
        isVendor: boolean = false;
        billingIndex: string = emptyString;
        entityId: string = emptyString;
        currency: string = 'USD';
        countryStates: Record<string, Record<string, string>> = {};
    }

    let _initArgs: InitArgs;
    let _formatter: Intl.NumberFormat;

    export function init(args: InitArgs): void {
        _initArgs = args;

        _formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: args.currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        addEvents();

        appn.ui.initCountryStateDropdown({
            countrySelector: '#CurrentEntity_Country',
            stateTextSelector: '#CurrentEntity_State',
            stateSelectSelector: '#CurrentEntity_State_Select',
            countryStates: args.countryStates
        });

        calcUsers();
        calcAddons();

        $('.buyInfo').hide();
        $('.backToTry').hide();
    }

    function addEvents() {
        $('#ForProvider_Id').change(function() {
            appn.location.navTo(_initArgs.billingIndex, [
                { name: 'forId', value: $('#ForProvider_Id').val() },
                { name: 'entityId', value: _initArgs.entityId }
            ]);
        });

        $('.row.users input').change(function() {
            calcUsers();
        });

        $('.row.users select').change(function() {
            calcUsers();
        });

        $('.card-body.tiers .buyLineQuantity').change(function() {
            calcTiers();
        });

        $('.card-body.tiers select').change(function() {
            calcTiers();
        });

        $('.row.addons .buyLineQuantity').change(function() {
            calcAddons();
        });

        $('.row.addons select').change(function() {
            calcAddons();
        });

        $('.btnTry').click(function(e) {
            e.preventDefault();

            const lineType = $(this).data('type');
            const lineDesc = $(this).data('desc');
            const trialDays = $(this).data('days') || 30;

            // Allow trials to be started without completed Billing details
            $('form#appnForm').attr('novalidate', 'novalidate')
                .validate().settings.ignore = '*';

            appn.dialog.confirm({
                modalColor: 'modal-info',
                title: T('Start Trial'),
                message: T('Start your {0} day trial now?', trialDays),
                buttons: {
                    confirm: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success'
                    }
                },
                callback: function(result: any) {

                    if (result) {
                        $('form#appnForm').append('<input type="hidden" name="TrialFor" value="' + lineType + '" />');
                        $('form#appnForm').append('<input type="hidden" name="TrialForDesc" value="' + lineDesc + '" />');
                        $('form#appnForm').submit();
                    }
                }
            });
        });

        $('.btnBuy').click(function(e) {
            e.preventDefault();
            const $lineContainer = $(this).closest('.billLine');
            $lineContainer.find('.btnTry').hide();
            $lineContainer.find('.btnBuy').hide();
            $lineContainer.find('.trialInfo').hide();
            $lineContainer.find('.tagLine').hide();
            $lineContainer.find('.backToTry').show();
            $lineContainer.find('.buyContainer').show();
            $lineContainer.find('.buyInfo').show();
            $lineContainer.find('.buyLineQuantity').val(1).trigger('change');

            const $tiersParent = $lineContainer.parents('.tiers');
            if ($tiersParent.length > 0) {
                $tiersParent.find('.btnBuy').hide();
                $tiersParent.find('.billLine').css('opacity', 0.5);
                $tiersParent.find('.billLine .select2').css('visibility', 'collapse')
                $lineContainer.css('opacity', 1);
                $lineContainer.find('.billLine .select2').css('visibility', 'visible');
            }
        });

        $('.backToTry').click(function(e) {
            e.preventDefault();
            const $lineContainer = $(this).closest('.billLine');
            $lineContainer.find('.btnTry').show();
            $lineContainer.find('.btnBuy').show();
            $lineContainer.find('.trialInfo').show();
            $lineContainer.find('.tagLine').show();
            $lineContainer.find('.buyContainer').hide();
            $lineContainer.find('.buyInfo').hide();
            $(this).hide();
            $lineContainer.find('.buyLineQuantity').val(0).trigger('change');

            const $tiersParent = $lineContainer.parents('.tiers');
            if ($tiersParent.length > 0) {
                $tiersParent.find('.btnBuy').show();
                $tiersParent.find('.billLine').css('opacity', 1);
                $tiersParent.find('.billLine .select2').css('visibility', 'visible');
            }
        });

        $('.buyLineQuantity').change(function(e) {
            const $lineContainer = $(this).closest('.billLine');
            const selected = $lineContainer.find('.buyLineQuantity').val() as number > 0;
            $lineContainer.find('.btnRemove').toggle(selected);
            $lineContainer.find('.btnActivate').toggle(!selected);
        });

        $('.btnRemove').click(function(e) {
            e.preventDefault();
            const $lineContainer = $(this).closest('.billLine');
            appn.dialog.confirm({
                modalColor: 'modal-danger',
                className: 'appnGlobalConfirmDelete',
                isDeleteAction: true,
                title: T('Confirm Removal'),
                message: T(`Are you sure you want to remove this subscription from your billing?
                              <br />
                              <br />
                              NOTE: Removal will be effective on your subscription's next renewal date.`),
                buttons: {
                    confirm: {
                        label: '<span>' + T('PROCEED') + '</span>',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: T('CANCEL')
                    }
                },
                callback: function(result: boolean) {
                    if (result)
                        $lineContainer.find('.buyLineQuantity').val(0).trigger('change');
                }
            });
        });

        $('.btnActivate').click(function(e) {
            e.preventDefault();
            $(this).closest('.billLine').find('.buyLineQuantity').val(1).trigger('change');
        });
    }

    function calcUsers() {
        $('.usersInfo').html(appn.emptyString);

        if (_initArgs.userPrmMonthRates.length > 0) {
            const userProBilling: UserBilling = new UserBilling(BillLineType.UserPro, _initArgs.userProMonthRates, _initArgs.userProYearRates, _initArgs.isTranched);
            setCostPreview(userProBilling, 'users', T('Pro Users'), 'pro-users');
            
            const userPrmBilling: UserBilling = new UserBilling(BillLineType.UserPrm, _initArgs.userPrmMonthRates, _initArgs.userPrmYearRates, _initArgs.isTranched);
            setCostPreview(userPrmBilling, 'users', T('Premium Users'), 'prm-users');
            
            const userStdBilling: UserBilling = new UserBilling(BillLineType.UserStd, _initArgs.userStdMonthRates, _initArgs.userStdYearRates, _initArgs.isTranched);
            setCostPreview(userStdBilling, 'users', T('Standard Users'), 'std-users');
            
            const userEdgeBilling: UserBilling = new UserBilling(BillLineType.UserEdge, _initArgs.userEdgeMonthRates, _initArgs.userEdgeYearRates, _initArgs.isTranched);
            setCostPreview(userEdgeBilling, 'users', T('Edge Users'), 'edge-users');
            
            // Show notice if < mintobill users
            if (_initArgs.minimumUsersToBill > 0 && (userPrmBilling.userCount + userStdBilling.userCount + userProBilling.userCount) < _initArgs.minimumUsersToBill)
            $('.usersInfo').text(T('A minimum of {0} Pro/Premium/Standard user(s) is required', _initArgs.minimumUsersToBill));
        } 
        else {
            const userGFBilling: UserBilling = new UserBilling(BillLineType.UserGF, _initArgs.userGFMonthRates, _initArgs.userGFYearRates, _initArgs.isTranched);
            setCostPreview(userGFBilling, 'users', T('Legacy Users'), 'gf-users');
            
            // Show notice if < mintobill users
            if (_initArgs.minimumUsersToBill > 0 && userGFBilling.userCount < _initArgs.minimumUsersToBill)
                $('.usersInfo').text(T('A minimum of {0} user(s) is required', _initArgs.minimumUsersToBill));
        }
    }

    function calcTiers() {
        setCostPreview(new ServiceBilling(BillLineType.DstlPrecision), 'tiers', T('Distill - Precision'), 'dstl-precision');
        setCostPreview(new ServiceBilling(BillLineType.DstlVantage), 'tiers', T('Distill - Vantage'), 'dstl-vantage');
        setCostPreview(new ServiceBilling(BillLineType.DstlSignature), 'tiers', T('Distill - Signature'), 'dstl-signature');
        
        setCostPreview(new ServiceBilling(BillLineType.SyncFlow), 'tiers', T('Sync - Flow'), 'sync-flow');
        setCostPreview(new ServiceBilling(BillLineType.SyncCascade), 'tiers', T('Sync - Cascade'), 'sync-cascade');
        setCostPreview(new ServiceBilling(BillLineType.SyncSurge), 'tiers', T('Sync - Surge'), 'sync-surge');
    }

    function calcAddons() {
        const webFormBilling: ServiceBilling = new ServiceBilling(BillLineType.WebForms);
        setCostPreview(webFormBilling, 'add-ons', T('Web Forms'), 'webforms');

        if (_initArgs.isVendor) {
            const vendorBilling: ServiceBilling = new ServiceBilling(BillLineType.Vendor);
            setCostPreview(vendorBilling, 'add-ons', T('Vendor Subscription'), 'vendor-sub');
        } 
        else {
            const entTkitBilling: ServiceBilling = new ServiceBilling(BillLineType.EntTkit);
            setCostPreview(entTkitBilling, 'add-ons', T('Enterprise Toolkit'), 'ent-tkit');
            
            const replicateBilling: ServiceBilling = new ServiceBilling(BillLineType.PlatformReplicate);
            setCostPreview(replicateBilling, 'add-ons', T('Platform Replicate'), 'pfm-replicate');
        }

        const androidBilling: ServiceBilling = new ServiceBilling(BillLineType.AaaSAndroid);
        setCostPreview(androidBilling, 'wlabel', `${T('App as a Service')} - Android`, 'aaas-android');

        const iosBilling: ServiceBilling = new ServiceBilling(BillLineType.AaaSIOS);
        setCostPreview(iosBilling, 'wlabel', `${T('App as a Service')} - iOS`, 'aaas-ios');

        const windowsBilling: ServiceBilling = new ServiceBilling(BillLineType.AaaSWindows);
        setCostPreview(windowsBilling, 'wlabel', `${T('App as a Service')} - Windows`, 'aaas-windows');
        
        const waaSBilling: ServiceBilling = new ServiceBilling(BillLineType.WaaS);
        setCostPreview(waaSBilling, 'wlabel', T('Web Portal as a Service'), 'waas');
    }

    let totals: {
        month: Record<string, number>;
        year: Record<string, number>;
    } = {
        month: {},
        year: {}
    };
    
    function setCostPreview(billing: ServiceBilling | UserBilling, totalCls: string, description: string, cls: string)
    {
        const $monthlyDiv = $('.costPreview .monthly .' + totalCls);
        const $annualDiv = $('.costPreview .annually .' + totalCls);

        $monthlyDiv.find('.' + cls).remove();
        $annualDiv.find('.' + cls).remove();
        
        totals.month[cls] = billing.monthTotal;
        totals.year[cls] = billing.yearTotal;
        
        if (billing.monthTotal > 0)
            $monthlyDiv.append(`<div class="${cls}">${description} <span class="text-right">${_formatter.format(billing.monthTotal)}</span>`);
        if (billing.yearTotal > 0)
            $annualDiv.append(`<div class="${cls}">${description} <span class="text-right">${_formatter.format(billing.yearTotal)}</span>`);
        
        const monthSum = Object.values(totals.month).reduce((acc, val) => acc + val, 0);
        const yearSum = Object.values(totals.year).reduce((acc, val) => acc + val, 0);
        
        const $cpMonth = $('.costPreview .monthly');
        $cpMonth.find('.grand-total').html(`${_formatter.format(monthSum)}`);
        // keep monthly visible even if zero in the event year is also zero, so we're always showing something
        if (monthSum > 0) {
            $cpMonth.show();
            $cpMonth.find('.still-deciding').hide();
        }
        else if (yearSum > 0)
            $cpMonth.hide();
        else {
            $cpMonth.show();
            $cpMonth.find('.still-deciding').show();
        }
        
        const $cpYear = $('.costPreview .annually');
        $cpYear.find('.grand-total').html(`${_formatter.format(yearSum)}`);
        if (yearSum > 0)
            $cpYear.show();
        else
            $cpYear.hide();
        
        const $divider = $('.costPreview .ma-divide');
        if (yearSum > 0 && monthSum > 0)
            $divider.show();
        else
            $divider.hide();
    }
    
    enum BillLineType {
        UserStd,
        UserPrm,
        UserEdge,
        UserPro,
        UserGF,
        AaaSAndroid,
        AaaSIOS,
        AaaSWindows,
        WaaS,
        Server,
        ServerManaged,
        Publish,
        PlatformReplicate,
        EntTkit,
        Vendor,
        Support,
        EdgeTx,
        WebForms,
        WebFormsTx,
        Other,
        SyncFlow,
        SyncCascade,
        SyncSurge,
        DstlPrecision,
        DstlVantage,
        DstlSignature
    }

    class UserBilling {
        constructor(billLineType: BillLineType, private readonly _monthRates: Array<UserRate>, private readonly _yearRates: Array<UserRate>,
                    isTranched: boolean) {
            this._type = BillLineType[billLineType];
            this._isTranched = isTranched;
        }

        private readonly _type: string;
        private readonly _isTranched: boolean;

        get monthTotal(): number {
            if (this.freq === 'Month')
                return this._isTranched ? this.calcTranchedTotal(this._monthRates) : this.calcBlockTotal(this._monthRates);
            return 0;
        }
        get yearTotal(): number {
            if (this.freq === 'Year')
                return this._isTranched ? this.calcTranchedTotal(this._yearRates) : this.calcBlockTotal(this._yearRates);
            return 0;
        }
        get userCount(): number {
            return Number($(`.${this._type} input`).val()) ?? 0;
        }
        get freq(): string {
            return String($(`.${this._type} select`).val());
        }

        private calcBlockTotal(rates: Array<UserRate>): number {
            const rate = rates.find(rate => this.userCount <= rate.key);
            return (rate?.value ?? 0) * this.userCount;
        }

        private calcTranchedTotal(rates: Array<UserRate>): number {
            let total = 0;
            let runningUserTotal = 0;

            $.each(rates, (index: number, rate: UserRate) => {
                if (this.userCount >= runningUserTotal + rate.key)
                    total += rate.key * rate.value;
                else
                    total += ((this.userCount - runningUserTotal) > 0 ? this.userCount - runningUserTotal : 0) * rate.value;

                runningUserTotal += rate.key;
            });

            if (rates.length > 0 && (this.userCount - runningUserTotal) > 0)
                total += (this.userCount - runningUserTotal) * rates.slice(-1)[0].value;

            return total;
        }
    }

    class ServiceBilling {
        constructor(billLineType: BillLineType, deviceOS?: string) {
            this._type = BillLineType[billLineType];
            this._deviceOS = deviceOS ?? '';
        }

        private readonly _type: string;
        private readonly _deviceOS: string;
        private _monthTotal: number = 0;
        private _yearTotal: number = 0;

        get monthTotal(): number {
            this.calcTotal();
            return this._monthTotal;
        }
        get yearTotal(): number {
            this.calcTotal();
            return this._yearTotal;
        }

        private calcTotal() {
            this._monthTotal = 0;
            this._yearTotal = 0;
            const serviceBilling = this;
            $(`.${this._type}${this._deviceOS ? "." + this._deviceOS : ""} .buyLineQuantity[value=1]`).each(function() {
                const freq = $(this).closest('.billLine').find('select').val();
                if (freq === 'Month')
                    serviceBilling._monthTotal += _initArgs.serviceMonthRates[serviceBilling._type];
                else
                    serviceBilling._yearTotal += _initArgs.serviceYearRates[serviceBilling._type];
            });
        }
    }

    interface UserRate {
        key: number;
        value: number;
    }

    interface ServiceRates {
        [key: string]: number;
    }
}
